<template>
  <v-card
      class="mx-auto donationleaderboard"
      max-width="360"
      :dark="isDark"



  >
    <v-row align="center" justify="center" style="margin-top:-10px;" >
      <v-col>
        <v-progress-linear
            :value="percentage_donated"
            color="#00c0ff"
            height="50"
            striped
            style="margin-top:-12px;"

        >
          <v-img

              style="position: absolute;z-index: -1;height:50px;left:0;top:0;mix-blend-mode: overlay; opacity: 0.3;filter: blur(1px) brightness(1.5);"
              :style="{'width':`${percentage_donated}%`}"
              :src="'https://media1.giphy.com/media/xT9Ighw18Ay7f0cIjS/giphy.gif'"

          >

          </v-img>
          <h2 style="color:white;" class="display-1">
            <b>{{amount_donated}}</b> kr
          </h2>

        </v-progress-linear>
      </v-col>
    </v-row>
    <v-tabs

        v-model="tab"
        color="#00c0ff"
        :dark="isDark"
        centered
        grow



    >
      <v-tab


          v-for="category in categories"
          :key="category"
      >
        {{ category }}
      </v-tab>
    </v-tabs>
    <v-tabs-items  :dark="isDark" v-model="tab">
      <v-tab-item
          :dark="isDark"


      >
        <v-list style="padding-bottom:4px;" :dark="isDark" >
          <v-list-item

              link
              v-for="(donation, i) in latest"
              :key="i"
              :dark="isDark"
              :style="{'background':colors[!isDark? 1 : 0][i % 2]}"


          >


            <v-chip label
                    :color=colorMe(donation.AMOUNT)
                    class="white--text"
            >

              {{donation.SENDER_NAME}}
              <v-chip
                  :dark=true

                  style="background: transparent;font-size:0.8em;padding-left: 10px;opacity: 0.7; margin-right: -8px;"
              >
                {{timePassed(donation.TIME_PASSED)}}
              </v-chip>
            </v-chip>



            <v-spacer></v-spacer>
            <v-chip color="transparent" :ripple="false">{{donation.AMOUNT}} kr</v-chip>
          </v-list-item>
        </v-list>
      </v-tab-item>

      <v-tab-item
          :dark="isDark"


      >
        <v-list :dark="isDark"
        >
          <v-list-item
              v-for="(donation, i) in top48"
              :key="i"
              :dark="isDark"
              :style="{'background':colors[!isDark? 1 : 0][i % 2]}"


          >
            <v-chip label
                    :color=colorMe(donation.AMOUNT_DONATED)
                    class="white--text"
            >
              {{donation.USER_NAME}}

            </v-chip>
            <v-spacer></v-spacer>
            <v-chip color="transparent" :ripple="false">{{donation.AMOUNT_DONATED}} kr</v-chip>
          </v-list-item>
        </v-list>
      </v-tab-item>

      <v-tab-item
          :dark="isDark"


      >
        <v-list :dark="isDark"
        >
          <v-list-item
              v-for="(donation, i) in top"
              :key="i"
              :dark="isDark"
              :style="{'background':colors[!isDark? 1 : 0][i % 2]}"

          >
            <v-chip label
                    :color=colorMe(donation.AMOUNT_DONATED)
                    class="white--text"
            >
              {{donation.SENDER_NAME}}

            </v-chip>
            <v-spacer></v-spacer>
            <v-chip color="transparent" :ripple="false">{{donation.AMOUNT_DONATED}} kr</v-chip>
          </v-list-item>
        </v-list>
      </v-tab-item>

    </v-tabs-items>


  </v-card>
</template>

<script>
export default {
  name: "BCFLeaderboard",
  props:["local","isDark"],
  data(){
    return{
      amount_donated:0,
      milestones:[5000,10000,25000,50000,75000,100000,150000,200000,250000,300000,350000,450000,500000,550000,600000,672491,800000,1000000,1250000,1500000,1500000,1750000,2000000,3000000,9000000,99000000],
      tab:0,
      categories:["Senaste","Stream","Dono"],
      latest:[],
      top48:[],
      top:[],
      colors:[["rgba(45,45,45,0.8)","rgba(36,36,36,0.8)"],["rgba(240,240,240,1)","rgba(250,250,250,1)"]]
    }
  },
  computed:{
    current_milestone:function(){

      for(let i=0;i<this.milestones.length;i++){
        if(this.amount_donated<this.milestones[i]){
          return this.milestones[i]
        }
      }
      return 2000000
    },
    percentage_donated:function(){


      return (this.amount_donated/this.current_milestone)*100;
    },
  },
  methods:{
    get_amount:function(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api//BCF_sum_donated';

      http.open('GET', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);

          self.amount_donated=parseInt(data.AMOUNT_DONATED);



        }

      };
      http.send();
    },
    get_top_stream(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/BCF_top_streamers';

      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      let self=this;
      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 403) {

          console.log("error");

        }
        else if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          self.top48=data;

        }

      };
      http.send();

    },
    get_top_donators(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/BCF_top_donators';

      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      let self=this;
      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 403) {

          console.log("error");

        }
        else if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          self.top=data;

        }

      };
      http.send();

    },
    get_latest(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let pathname = window.location.pathname.substring(1);
      let url = '/api/BCF_latest_donations_local?path=' + pathname;
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      let self=this;
      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 403) {

          console.log("error");

        }
        else if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          self.latest=data;

        }

      };
      http.send();

    },

    colorMe(amount){
      if(parseInt(amount)>499){
        return "orange"
      }
      else if(parseInt(amount)>99){
        return "purple"
      }
      else if(parseInt(amount)>49){
        return "blue"
      }
      else if(parseInt(amount)>20){
        return "green"
      }
      else{
        return "#3f3f3f"
      }
    },

    timePassed(time){
      if(time>6048000){
        return "10+ v"
      }
      else if(time>1209600){
        return `${Math.floor(time/1209600)} w`
      }
      else if(time>1209600){
        return `${Math.floor(time/1209600)} w`
      }
      else if(time>86400){
        return `${Math.floor(time/86400)} d`
      }
      else if(time>86400){
        return `${Math.floor(time/86400)} d`
      }
      else if(time>3600){
        return `${Math.floor(time/3600)} h`
      }
      else if(time>120){
        return `${Math.floor(time/60)} m`
      }
      else{
        return "nu"
      }
    }
  },
  mounted:function(){
    this.get_top_stream();
    this.get_top_donators();
    this.get_amount();
    this.get_latest();
    let self=this;
    setInterval(function(){
      self.get_top_stream();
      self.get_top_donators();
      self.get_amount();
      self.get_latest()
    },30000)


  }
}
</script>

<style scoped>

.glow {
  text-align: center;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {

    box-shadow: 0 0 10px rgba(255, 255, 255, 0.91), 0 0 20px rgba(255, 255, 255, 0.8), 0 0 30px #545454, 0 0 40px rgba(0, 203, 230, 0.74), 0 0 50px rgba(0, 176, 230, 0.56), 0 0 60px rgba(29, 163, 220, 0.88), 0 0 70px rgba(0, 203, 230, 0.74);
  }
  to {
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.95), 0 0 30px rgba(77, 240, 255, 0.44), 0 0 40px rgba(77, 213, 255, 0.66), 0 0 50px rgba(77, 166, 255, 0.66), 0 0 60px rgba(77, 193, 255, 0.68), 0 0 70px rgba(92, 250, 175, 0.87), 0 0 80px rgba(0, 188, 230, 0.86);
  }
}



</style>
